import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/shared/services/login.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-account-password.component.html',
  styleUrls: ['./reset-account-password.component.scss']
})
export class ResetAccountPasswordComponent implements OnInit {
  public user: string = null;
  public validTime: string = null;
  public config: any;
  public isLoading: boolean
  public error: boolean;
  public success: boolean;
  public inProgress: boolean;
  private errMsg: string;
  private passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!#%*?^_&]{12,20}$/;
  ResetPasswordForm = this.fb.group({
    newPassword: [null, Validators.required],
    confirmPassword: [null, Validators.required]
  });
  successMsg: string;
  constructor(
    private router: Router,
    private loginService: LoginService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.user = this.activatedRoute.snapshot.queryParamMap.get('user');
    this.validTime = this.activatedRoute.snapshot.queryParamMap.get('cdtid');
    this.config = JSON.parse(sessionStorage.getItem('config'));

    this.verify()
  }

  verify() {
    var givenDate = new Date(atob(this.validTime));
    var currentDate = new Date();
    var timeDiff = Math.floor((currentDate.getTime() - givenDate.getTime()) / 1000);
    if ((this.user === null || this.validTime === null) || timeDiff > 1800 ) {
      alert("Invalid URL");
      this.router.navigate(['/']);
      return;
    }
  }

  validatePassword() {
    this.error = false;
    this.success = false;
    this.inProgress = true;
    let password: string = this.ResetPasswordForm.controls.newPassword.value;
    let cfrmPassword: string = this.ResetPasswordForm.controls.confirmPassword.value;
    if (password && !password.match(this.passwordPattern)) {
      window.scrollTo(0, 0)
      this.error = true;
      this.inProgress = false;
      this.errMsg = "Password format is incorrect";
      return
    } else if (password !== cfrmPassword) {
      window.scrollTo(0, 0)
      this.error = true;
      this.inProgress = false;
      this.errMsg = "Password do not match";
      return
    }

    let jsonData =
    {
      'username': this.user,
      'newPassword': btoa(password),
      'site': 'RC3'
    };

    this.loginService.resetAccountPassword(jsonData).subscribe(res => {
      if (res['status'] == 0) {
        window.scrollTo(0, 0);
        this.inProgress = false
        this.successMsg = "Password has been reset. Please login"
        this.success = true;
        alert(this.successMsg);
        this.router.navigate(['/login']);
      } else {
        window.scrollTo(0, 0);
        this.inProgress = false
        this.errMsg = "Unable to reset password. Please try again."
        this.success = true;
        alert(this.errMsg);
      }
    }, err => {
      this.inProgress = false
      this.error = true;
      this.errMsg = "Unable to reset password. Please try again.";
    });
  }
}
